import { useRef, useState } from "react";
import industries from "../../assets/img/IndustriesIMG/Logistics.png";
import Cybersecurity from "../../assets/img/IndustriesIMG/Cybersecurity.png";
import Fintech from "../../assets/img/IndustriesIMG/Fintech.png";
import Banking from "../../assets/img/IndustriesIMG/Banking.png";
import Ecommerce from "../../assets/img/IndustriesIMG/Ecommerce.png";
import Telemedicine from "../../assets/img/IndustriesIMG/Telemedicine.png";
import Telecommunication from "../../assets/img/IndustriesIMG/Telecommunication.png";
import Government from "../../assets/img/IndustriesIMG/Government.png";
import Business from "../../assets/img/IndustriesIMG/Business.png";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
const blogData = [
  {
    image: industries,
    title: "Logistics & Supply Chain",
    text: " Optimizing supply chain operations with cutting-edge solutions for warehousing, transportation, and inventory management.",
  },
  {
    image: Government,
    title: "Government & Public Services",
    text: "Supporting public sector transformation with secure, efficient, and citizen-centric solutions.",
  },
  {
    image: Business,
    title: "Business Process Outsourcing",
    text: "Streamlining operations and enhancing efficiency through comprehensive BPO solutions and AI.",
  },
  {
    image: Telecommunication,
    title: "Telecommunication",
    text: "Advanced communication solutions powering next-generation connectivity and network infrastructure.",
  },
  {
    image: Telemedicine,
    title: "Health & Telemedicine",
    text: "Digital healthcare solutions enabling remote patient care and efficient medical service delivery.",
  },
  {
    image: Ecommerce,
    title: "E-commerce & Retail",
    text: "Comprehensive digital solutions for modern retail operations and online shopping experiences.",
  },
  {
    image: Banking,
    title: "Banking",
    text: "Secure and scalable solutions for modern banking operations, risk management, and customer service excellence.",
  },
  {
    image: Fintech,
    title: "Fintech & Digital Payment",
    text: "Innovative financial technology solutions for secure and seamless digital transactions.",
  },
  {
    image: Cybersecurity,
    title: "Cybersecurity & AI Solutions",
    text: "Advanced security solutions powered by artificial intelligence and machine learning.",
  },
];

// const Industries = () => {
//   const marqueeRef = useRef(null);
//   const [isDragging, setIsDragging] = useState(false);
//   const [startX, setStartX] = useState(0);
//   const [scrollLeft, setScrollLeft] = useState(0);

//   const handleMouseDown = (e) => {
//     if (!marqueeRef.current) return;
//     setIsDragging(true);
//     setStartX(e.pageX - marqueeRef.current.offsetLeft);
//     setScrollLeft(marqueeRef.current.scrollLeft);
//   };

//   const handleMouseLeave = () => setIsDragging(false);
//   const handleMouseUp = () => setIsDragging(false);

//   const handleMouseMove = (e) => {
//     if (!isDragging || !marqueeRef.current) return;
//     e.preventDefault();
//     const x = e.pageX - marqueeRef.current.offsetLeft;
//     const walk = (x - startX) * 5; // Adjust scrolling speed
//     marqueeRef.current.scrollLeft = scrollLeft - walk;
//   };

//   return (
//     <div
//       className="marquee"
//       ref={marqueeRef}
//       onMouseDown={handleMouseDown}
//       onMouseLeave={handleMouseLeave}
//       onMouseUp={handleMouseUp}
//       onMouseMove={handleMouseMove}>
//       <div className="marquee_content">
//         {[...blogData, ...blogData].map((blog, index) => (
//           <div className="industries_container" key={index}>
//             <div className="industries_card_container">
//               <div className="industries_card_img">
//                 <img
//                   src={blog.image}
//                   alt={blog.title}
//                   className="industries_main_img"
//                 />
//               </div>
//               <div className="industries_card_text_container">
//                 <h2 className="industries_text">{blog.title}</h2>
//                 <p className="industries_text_sub">{blog.text}</p>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Industries;

const Industries = () => {
  const marqueeRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    if (!marqueeRef.current) return;
    setIsDragging(true);
    setStartX(e.pageX - marqueeRef.current.offsetLeft);
    setScrollLeft(marqueeRef.current.scrollLeft);
  };

  const handleMouseLeave = () => setIsDragging(false);
  const handleMouseUp = () => setIsDragging(false);

  const handleMouseMove = (e) => {
    if (!isDragging || !marqueeRef.current) return;
    e.preventDefault();
    const x = e.pageX - marqueeRef.current.offsetLeft;
    const walk = (x - startX) * 5;
    marqueeRef.current.scrollLeft = scrollLeft - walk;
  };

  const scroll = (direction) => {
    if (!marqueeRef.current) return;
    const scrollAmount = 300;
    marqueeRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div className="relative">
      {/* Left Arrow */}
      <button
        onClick={() => scroll("left")}
        className="arrow-button left"
        aria-label="Scroll Left">
        <FiArrowLeft size={20} />
      </button>

      <button
        onClick={() => scroll("right")}
        className="arrow-button right"
        aria-label="Scroll Right">
        <FiArrowRight size={20} />
      </button>

      <div
        className="marquee overflow-x-auto scroll-smooth"
        ref={marqueeRef}
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}>
        <div className="marquee_content flex gap-4">
          {[...blogData, ...blogData].map((blog, index) => (
            <div className="industries_container min-w-[300px]" key={index}>
              <div className="industries_card_container">
                <div className="industries_card_img">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="industries_main_img"
                  />
                </div>
                <div className="industries_card_text_container">
                  <h2 className="industries_text">{blog.title}</h2>
                  <p className="industries_text_sub">{blog.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Industries;
